import { render, staticRenderFns } from "./CanvasOverviewPage.vue?vue&type=template&id=623924f7"
import script from "./CanvasOverviewPage.vue?vue&type=script&lang=js"
export * from "./CanvasOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports